import React from 'react';
import { Link } from 'react-router';

import ProductLink from '~/components/products/product-link';
import { shedArticleRoute } from '~/routes';
import { assetUrlFor } from '~/sanity/assets';
import { captureException } from '~/utils/exception-tracking';

export const productContentSerializers = {
  types: {
    seedSpecIcons: () => null,
  },
  marks: {
    link: ({ mark, children }) => {
      const { href, linkType } = mark;

      switch (linkType) {
        case 'articleLink':
          const { category, slug: articleSlug } = mark.articleLink;
          return (
            <Link
              to={shedArticleRoute({
                category: category.articleCategory.slug,
                slug: articleSlug,
              })}
            >
              {children}
            </Link>
          );

        case 'productLink':
          return (
            <ProductLink slug={mark.productLink.slug}>{children}</ProductLink>
          );

        case 'generalLink':
          let parsed;
          try {
            parsed = new URL(href);
          } catch (e) {
            captureException(
              new Error('Error parsing URL in ProductDetailsModal', {
                extras: {
                  children,
                },
              })
            );
            return children;
          }

          if (parsed.host.includes('getsunday.com')) {
            return <Link to={parsed.pathname}>{children}</Link>;
          }

          return (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          );

        case 'fileLink':
          return (
            <a
              href={assetUrlFor(mark.fileLink?.asset)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {children}
            </a>
          );

        default:
          return (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          );
      }
    },
    small: ({ children }) => {
      return <small>{children}</small>;
    },
  },
};
